import { faqs } from "@/mocks/trends";

export default function About() {
  const testimonialList = [
    { name: "阿明", city: "杭州", text: "每天上班先看一遍实时热搜，跟同事聊八卦终于不掉队了。" },
    { name: "荔枝", city: "成都", text: "界面干净看着舒服，热度条一眼就能看出来话题有多火。" },
    { name: "老周", city: "深圳", text: "分类很清楚，我只看财经那栏，比刷十几个 app 高效多了。" },
  ];

  return (
    <section id="about" className="w-full scroll-mt-20">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-700">
              <i className="ri-information-line"></i> ABOUT US
            </span>
            <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">关于吃瓜合集</h2>
            <p className="mt-4 leading-relaxed text-foreground-700 md:text-base">
              <strong className="font-semibold text-foreground-950">吃瓜合集</strong> 是一个专注聚合全网热点讨论的中文内容社区，
              我们把正在被大量讨论的话题按热度聚合到一处，帮你在信息洪流里快速看清
              <strong className="font-semibold text-primary-700">“大家最近在聊什么”</strong>。
            </p>
            <p className="mt-3 leading-relaxed text-foreground-700">
              我们坚持独立、克制地呈现热度本身——不站队、不造势、不下结论，仅如实反映公开讨论的规模与走向，
              并把信息的来龙去脉尽量讲清楚，让每一位吃瓜群众都能做出自己的判断。
            </p>
            <div className="mt-5 grid grid-cols-3 gap-3">
              {[
                { icon: "ri-eye-line", t: "客观呈现" },
                { icon: "ri-flashlight-line", t: "实时更新" },
                { icon: "ri-compass-3-line", t: "不站队" },
              ].map((v) => (
                <div key={v.t} className="rounded-xl bg-background-100 px-3 py-4 text-center">
                  <i className={`${v.icon} text-2xl text-primary-500`}></i>
                  <div className="mt-2 text-sm font-semibold text-foreground-800">{v.t}</div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold text-foreground-950">数据是如何聚合的</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              我们的榜单与热搜参考全网多个主流公开平台的讨论数据进行综合，核心维度包括讨论量、阅读量、分享量与热度走势。
            </p>
            <ul className="mt-4 space-y-3">
              {[
                { icon: "ri-discuss-line", title: "讨论规模", desc: "评论、转发、弹幕等互动量的综合评估" },
                { icon: "ri-bar-chart-line", title: "热度趋势", desc: "一定时间窗口内的讨论增速与持续度" },
                { icon: "ri-shield-check-line", title: "信源核实", desc: "存疑瓜料标注来源，不轻信单方说法" },
              ].map((v) => (
                <li key={v.title} className="flex items-start gap-3 rounded-xl border border-background-200 bg-background-100 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={`${v.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-950">{v.title}</h4>
                    <p className="mt-0.5 text-xs text-foreground-600">{v.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <h3 className="mt-6 text-lg font-bold text-foreground-950">吃瓜群众怎么说</h3>
            <div className="mt-3 grid gap-3 sm:grid-cols-3">
              {testimonialList.map((t) => (
                <figure key={t.name} className="rounded-xl border border-background-200 bg-background-100 p-4">
                  <div className="flex text-accent-500">
                    {[0, 1, 2, 3, 4].map((i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="mt-2 text-xs leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                  <figcaption className="mt-2 text-xs font-semibold text-foreground-950">
                    {t.name} · {t.city}
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>

        {/* FAQ 统计展示辅助 */}
        <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-background-200 pt-6 text-xs text-foreground-500">
          <span>
            <i className="ri-database-2-line mr-1"></i> 已收录 {faqs.length} 类平台规则
          </span>
          <span>·</span>
          <span>内容仅供信息参考，不构成任何观点或建议</span>
          <span>·</span>
          <span>更新时间：2026-09-07</span>
        </div>
      </div>
    </section>
  );
}